<template>
  <div class="_infoheader">
    <div class="row __wrapper_" v-if="isError || !contractData">
      Server Error 500 !!!
    </div>
    <div v-else>
      <div v-if="isLoading" class="d-flex justify-content-center mb-3">
        <b-spinner label="Loading..."></b-spinner>
      </div>
      <div class="row m-0" v-else>
        <!-- <div class="_infoheader_back" @click="goBack">
          <img src="@/assets/image/icon/left-arrow-blue.svg" alt="">
          <span>Back</span>
        </div> -->
        <div @click="$router.go(-1)" class="back__button">
          <img src="@/assets/image/icon/arrow-back-full-yellow.svg" alt="">
          <span class="pl-2">Back</span>
        </div>
        <div class="col-md p-0 _infoheader__left">
          <div class="row _infoheader__leftCol--texttop">
            <span class="__text">Booking Form</span>
          </div>
          <div class="row _infoheader__leftCol--texttop">
            <img class="__img" src="@/assets/image/icon/plane.svg">
            <span class="__text">[{{ contractData.city_from }} {{ contractData.country_from }}] {{ contractData.cityf }} to [{{ contractData.city_to }} {{ contractData.country_to }}] {{ contractData.cityt }}</span>
          </div>
          <div class="row _infoheader__leftCol--texttop">
            <span class="textwhite">{{ getFreigtMode(contractData.service_head) }} / {{getShipmentType(contractData.shipment_type.replace(/SEA/g,'')) }}</span>
          </div>
          <!-- <p class="_infoheader__leftCol--textmiddle"><span class="__ft">{{ contractData.service_head }} {{ contractData.shipment_type }}</span> <span class="__type" v-if="contractData.service_sub_type === 'OCEAN'">| {{ contractData.service_sub_type }}</span></p> -->
          <p class="_infoheader__leftCol--textbottom" v-if="contractData.status === 3" > Canceled </p>
          <p class="_infoheader__leftCol--textbottom" v-else>{{ statusBid }}</p>
        </div>
        <div class="col-md _infoheader__middle">
          <div class="row">
            <div class="col-md-4 pr-0">Contract Duration</div>
            <div class="col-md">: {{ getDate2(contractData.duration_start) }} - {{ getDate2(contractData.duration_end) }}</div>
          </div>
          <div class="row">
            <div class="col-md-4 pr-0">Freight Mode</div>
            <div class="col-md">: {{ getFreigtMode(contractData.service_head) }}</div>
          </div>
          <div class="row">
            <div class="col-md-4 pr-0">Shipment Type</div>
            <div class="col-md">: {{getShipmentType(contractData.shipment_type.replace(/SEA/g,'')) }}</div>
          </div>
          <div class="row">
            <div class="col-md-4 pr-0">Total Shipment</div>
            <div class="col-md">: {{ contractData.totalshipment}}</div>
          </div>
          <!-- FCL -->
          <div class="row" v-if="contractData.shipment_type && contractData.shipment_type.includes('FCL')">
            <div class="col-md-4 pr-0">Container Size</div>
            <div class="col-md">: {{ contractData.container_size ? contractData.container_size : '-' }}</div>
          </div>
          <div class="row" v-if="contractData.shipment_type && contractData.shipment_type.includes('FCL')">
            <div class="col-md-4 pr-0">Container Type</div>
            <div class="col-md">: {{ contractData.service_sub_type }} </div>
          </div>
          <div class="row" v-if="contractData.shipment_type && contractData.shipment_type.includes('FCL') && contractData.container_option">
            <div class="col-md-4 pr-0">Container Option</div>
            <div class="col-md">: {{ getContainerOption(contractData.container_option) }} </div>
          </div>
          <div class="row" v-if="contractData.shipment_type && contractData.shipment_type.includes('FCL')">
            <div class="col-md-4 pr-0">Temperature</div>
            <div class="col-md">: {{ contractData.service_sub_type === 'Reefer' ? contractData.temperature+ ' &#8451;' : '-' }}</div>
          </div>
          <div class="row" v-if="contractData.shipment_type && contractData.shipment_type.includes('FCL') && contractData.weight_estimation">
            <div class="col-md-4 pr-0">Weight Estimation</div>
            <div class="col-md">: {{ contractData.weight_estimation }} Kg</div>
          </div>
          <!-- END FCL -->
          <!-- <div class="row">
            <div class="col-md-4 pr-0">Estimate Contract Value</div>
            <div class="col-md">: IDR {{ contractData.estimate_contract_value ? contractData.estimate_contract_value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0 }}</div>
          </div> -->
          <div class="row" v-if="(contractData.shipment_type === 'AIRCARGO' || contractData.shipment_type === 'AIRCOURIER' || contractData.shipment_type === 'SEALCL')">
            <div class="col-md-4 pr-0">Quantity</div>
            <div class="col-md">: {{ contractData.total_quantity }} {{ contractData.satuan}}</div>
          </div>
          <!-- AIR / LCL -->
          <div class="row" v-if="(contractData.shipment_type === 'AIRCARGO' || contractData.shipment_type === 'AIRCOURIER' || contractData.shipment_type === 'SEALCL')">
            <div class="col-md-4 pr-0">Weight</div>
            <div class="col-md">: {{ contractData && contractData.shipment_type === 'AIRCOURIER' ? parseFloat(contractData.total_weight, 0).toFixed(1) : parseFloat(contractData.total_weight, 0) }} Kg</div>
          </div>
          <div class="row" v-if="(contractData.shipment_type === 'AIRCARGO' || contractData.shipment_type === 'AIRCOURIER')">
            <div class="col-md-4 pr-0">Volume</div>
            <div class="col-md">: {{ parseFloat(contractData.estimateddimension) % 1 !== 0 ? parseInt(contractData.estimateddimension) + 1 : parseInt(contractData.estimateddimension)}} volumetric</div>
          </div>
          <div class="row" v-if="(contractData.shipment_type === 'SEALCL')">
            <div class="col-md-4 pr-0">Volume</div>
            <div class="col-md">: {{ contractData.estimateddimension }} cbm</div>
          </div>
          <div class="row" v-if="(contractData.shipment_type === 'AIRCARGO' || contractData.shipment_type === 'AIRCOURIER' || contractData.shipment_type === 'SEALCL')">
            <div class="col-md-4 pr-0">Dimension</div>
            <div class="col-md">: {{ getDimension(contractData.dimension) }}</div>
          </div>
          <!-- END AIR / LCL -->
          <!-- FCL -->
          <div class="row" v-if="contractData.shipment_type && contractData.shipment_type.includes('FCL')">
            <div class="col-md-4 pr-0">Total Container</div>
            <div class="col-md">: {{ contractData.total_weight}} Container </div>
          </div>
          <div class="row" v-if="contractData.shipment_type && contractData.shipment_type.includes('FCL')">
            <div class="col-md-4 pr-0">Estimate Container Permonth</div>
            <div class="col-md">: {{ contractData.estimateddimension }} Container</div>
          </div>
          <!-- END FCL -->

        </div>
        <div class="col-md _infoheader__right">
          <div class="row">
            <div class="col-md-4">Product Type</div>
            <div class="col">: {{ getProductType(contractData.product_class) }}</div>
          </div>
          <div class="row">
            <div class="col-md-4">Kind of Goods</div>
            <div class="col">: {{ contractData.product_type ? contractData.product_type : '-' }}</div>
          </div>
          <div class="row" v-if="contractData.product_class === 'DG' && contractData.un_number">
            <div class="col-md-4">UN Number</div>
            <div class="col">: {{ contractData.un_number }}</div>
          </div>
          <div class="row">
            <div class="col-md-4">Value of Goods</div>
            <div class="col">: IDR {{ contractData.total_price ? contractData.total_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0 }}</div>
          </div>
          <div class="row">
            <div class="col-md-4">HS Code</div>
            <div class="col">: {{ contractData.hs_code }}</div>
          </div>
          <div class="row">
            <div class="col-md-4">Product Description</div>
            <div class="col">: {{ contractData.description }}</div>
          </div>
          <div class="row">
            <div class="col-md-4">Shipment Service</div>
            <div class="col">: {{ getOptionTp(contractData.optiontp) }}</div>
          </div>
          <!--  -->
          <div class="_infoheader__rightCol--card">
            <b-card no-body class="mb-1">
              <b-collapse id="accordion2" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <div class="row">
                    <div class="col-md-4">Origin Country</div>
                    <div class="col">: {{ contractData.countryf }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-4">Origin City</div>
                    <div class="col">: {{ contractData.cityf }}</div>
                  </div>
                  <div class="row" v-if="(contractData.optiontp === 'dtp' || contractData.optiontp === 'dtd')">
                    <div class="col-md-4">Pickup Address</div>
                    <div class="col">: {{ contractData.pickup_address ? contractData.pickup_address : contractData.delivery_address_ori ? contractData.delivery_address_ori : '-' }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-4">Destination Country</div>
                    <div class="col">: {{ contractData.countryt }}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-4">Destination City</div>
                    <div class="col">: {{ contractData.cityt }}</div>
                  </div>
                  <div class="row" v-if="(contractData.optiontp === 'ptd' || contractData.optiontp === 'dtd')">
                    <div class="col-md-4">Delivery Address</div>
                    <div class="col">: {{ contractData.delivery_address ? contractData.delivery_address : contractData.delivery_address_desti ? contractData.delivery_address_desti : '-'}}</div>
                  </div>
                  <div class="row">
                    <div class="col-md-4">Ideal Budget</div>
                    <div class="col">: IDR {{ contractData.request_rate ? contractData.request_rate.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0 }} - IDR {{ contractData.request_rate_to ? contractData.request_rate_to.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0 }}</div>
                  </div>
                  <!-- <div class="row">
                    <div class="col-md-4">Term of Payment</div>
                    <div class="col">: {{ contractData.term_of_payment }} days</div>
                  </div> -->
                  <div class="row">
                    <div class="col-md-4">Additional Option</div>
                    <!-- <div class="col">
                      :  <small v-if="contractData.option_insurance === '1'"> Insurance, </small> <small v-if="contractData.option_customs_clearance === '1'"> Custom <br>
                      Clearance (Origin), <br></small>
                      <small v-if="contractData.option_customs_clearance_destination === '1'">Custom Clearance <br>
                      (Destination), <br></small>
                      <small v-if="contractData.option_dangerous_goods === '1'">Dangerous Goods</small>
                    </div> -->
                    <div class="col">
                      :  {{getAdditional(contractData.option_customs_clearance, contractData.option_customs_clearance_destination, contractData.option_dangerous_goods, contractData.option_estimate_storage)}}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4">Remarks</div>
                    <div class="col">: {{ contractData.note_for_merchant ? contractData.note_for_merchant : '-' }}</div>
                  </div>
                </b-card-body>
              </b-collapse>
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button class="col justify-content-end _infoheader__rightCol--showhide" href="#" v-b-toggle.accordion2>Show More</b-button>
              </b-card-header>
            </b-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as moment from 'moment'

export default {
  name: 'InfoHeader',
  props: {
    statusBid: String
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      contractData: 'contract/item',
      isLoading: 'contract/isLoading',
      isError: 'contract/error'
    })
  },
  methods: {
    getContainerOption (data) {
      if (data === 'SOC') { return `Shipper's Own Container (SOC)` } else if (data === 'COC') { return `Carrier's Owned Container (COC)` } else { return '-' }
    },
    getDimension (dimension) {
      if (dimension) {
        const newdimension = JSON.parse(dimension)
        return (`${newdimension.length ? newdimension.length : '0'}x${newdimension.width ? newdimension.width : '0'}x${newdimension.height ? newdimension.height : '0'} cm`)
      }
    },
    getProductType (item) {
      if (item === 'GENCO') {
        return 'General Cargo'
      }
      if (item === 'SC') {
        return 'Special Cargo'
      }
      if (item === 'DG') {
        return 'Dangerous Goods'
      }
    },
    goBack () {
      localStorage.removeItem('bookingForm')
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push('/')
    },
    getAdditional (customsClearance, clearanceDestination, dangerousGoods, estimateStorage) {
      let additional = []
      if (customsClearance === 'true') { additional.push('Custom Clearance (Origin)') }
      if (clearanceDestination === 'true') { additional.push('Custom Clearance (Destination)') }
      if (estimateStorage === 'true') { additional.push('Estimate Storage') }
      return (additional.length > 0 ? additional.join(',\n') : '-')
    },
    getDate (date) {
      return moment(date).format('DD/MM/YY')
    },
    getDate2 (date) {
      return moment(date).format('DD MMM YYYY')
    },
    getFreigtMode (mode) {
      if (mode === 'OCEAN') { return 'Ocean' }
      if (mode === 'AIR') { return 'Air' }
    },
    getShipmentType (type) {
      if (type === 'AIRCARGO') {
        const newType = type.replace('AIRCARGO', 'Air Cargo')
        return newType
      } else if (type === 'AIRCOURIER') {
        const newType = type.replace('AIRCOURIER', 'Air Courier')
        return newType
      } else {
        if (type !== 'LCL') { return type } else { return 'LCL' }
      }
    },
    getOptionTp (type) {
      let optionTp = '-'
      switch (type) {
        case 'ptp' : optionTp = 'Port to Port'
          break
        case 'dtp' : optionTp = 'Door to Port'
          break
        case 'dtd' : optionTp = 'Door to Door'
          break
        case 'ptd' : optionTp = 'Port to Door'
          break
        default : optionTp = '-'
        /* eslint-disable-next-line */
      }
      /* eslint-disable-next-line */
      return optionTp
      /* eslint-disable-next-line */
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/requestList/requestStatusContract/InfoHeader.vue